import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export const keys = {
    all: ["object-tag-values"],
    configuration: (groupID: number, configurationID: number) => [
        ...keys.all,
        "configuration", {
            groupID,
            configurationID
        }
    ],
    configurationLists: () => [
        ...keys.all,
        "configurationList"
    ],
    configurationList: (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number
    ) => [
            ...keys.configurationLists(),
            {
                groupID,
                objectType,
                objectID
            }
        ],
    configurationDefaultOptions: (
        groupID: number,
        configurationID: number,
        objectType?: eLynxObjectTypeEnum,
        objectID?: number,
    ) => [
            ...keys.all,
            "configurationDefaultOptions", {
                groupID,
                configurationID,
                objectType,
                objectID
            }
        ],

    availableItemLists: () => [
        ...keys.all,
        "availableItemLists"
    ],
    availableItemList: (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number
    ) => [
            ...keys.availableItemLists(),
            {
                groupID,
                objectType,
                objectID
            }
        ],
};
